import React, { useEffect, useRef } from 'react';

// GPTスロット要素ID
const slotElementId = 'div-gpt-ad-1768883112321-0';

/**
 * モバイル用広告バナー
 */
const MobileAd = () => {

  // 広告が表示されたかどうかのフラグ（googletag.displayの多重実行を防ぐ）
  const displayedRef = useRef(false);

  useEffect(() => {
    // 一度displayしたら、同一コンポーネント生存中は繰り返さない
    if (displayedRef.current) {
      return;
    }

    try {
      window.googletag = window.googletag || { cmd: [] };
      window.googletag.cmd.push(function () {
        window.googletag.display(slotElementId);
        // display実行済みフラグを立てる
        displayedRef.current = true;
      });
    } catch (e) {
    }
  }, []);

  return (
    <div className="mobile-ad-banner">
      <div id={slotElementId}></div>
    </div>
  );
};

export default MobileAd;